module.exports = __webpack_public_path__ + "b1199926f1495deb26556e64dd403da7.jpg";